(function () {
  var VIEW_STORAGE_KEY = 'tim-west-gallery-view';
  var VALID_VIEWS = ['grid', 'scroll'];

  function getStoredView() {
    try {
      var stored = window.localStorage.getItem(VIEW_STORAGE_KEY);
      if (stored && VALID_VIEWS.indexOf(stored) !== -1) return stored;
    } catch (error) {}
    return 'grid';
  }

  function isScrollView() {
    return document.documentElement.getAttribute('data-gallery-view') === 'scroll';
  }

  function setViewToggleState(view) {
    var buttons = document.querySelectorAll('.gallery-view-toggle button[data-view]');
    buttons.forEach(function (button) {
      button.setAttribute('aria-selected', button.getAttribute('data-view') === view ? 'true' : 'false');
    });
  }

  function statusText(view, count) {
    var noun = count === 1 ? 'photograph' : 'photographs';
    if (view === 'scroll') {
      return count + ' ' + noun + ' · scroll, arrow keys, or use the on-screen arrows';
    }
    return count + ' ' + noun + ' · click any photograph to view prints';
  }

  function applyGalleryView(view, count) {
    if (VALID_VIEWS.indexOf(view) === -1) view = 'grid';
    document.documentElement.setAttribute('data-gallery-view', view);
    setViewToggleState(view);
    var status = document.getElementById('gallery-status');
    if (status) status.textContent = statusText(view, count);
    try {
      window.localStorage.setItem(VIEW_STORAGE_KEY, view);
    } catch (error) {}
  }

  function initGalleryInteractions() {
    var frames = Array.prototype.slice.call(document.querySelectorAll('.gallery-frame'));
    var progressBar = document.querySelector('.gallery-progress-bar');
    var prevButton = document.getElementById('gallery-prev');
    var nextButton = document.getElementById('gallery-next');
    var topButton = document.getElementById('gallery-top');
    var hint = document.getElementById('gallery-hint');
    var toggle = document.querySelector('.gallery-view-toggle');
    var count = frames.length;

    applyGalleryView(getStoredView(), count);

    if (toggle) {
      toggle.addEventListener('click', function (event) {
        var button = event.target.closest('button[data-view]');
        if (!button) return;
        applyGalleryView(button.getAttribute('data-view'), count);
      });
    }

    if (!frames.length) return;

    var hintHidden = false;

    function hideHint() {
      if (hintHidden || !hint) return;
      hintHidden = true;
      hint.classList.add('is-hidden');
    }

    function getActiveIndex() {
      var activeIndex = frames.findIndex(function (frame) {
        return frame.classList.contains('is-active');
      });
      return activeIndex < 0 ? 0 : activeIndex;
    }

    function setActiveFrame(index) {
      frames.forEach(function (frame, frameIndex) {
        frame.classList.toggle('is-active', frameIndex === index);
      });
      if (prevButton) prevButton.disabled = index <= 0;
      if (nextButton) nextButton.disabled = index >= frames.length - 1;
    }

    function scrollToFrame(index) {
      if (!isScrollView() || index < 0 || index >= frames.length) return;
      hideHint();
      frames[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActiveFrame(index);
    }

    function updateProgress() {
      if (!isScrollView() || !progressBar || frames.length < 2) return;
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      var ratio = maxScroll > 0 ? scrollTop / maxScroll : 0;
      progressBar.style.width = Math.max(4, ratio * 100) + '%';
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (!isScrollView()) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              var index = Number(entry.target.getAttribute('data-index') || 0);
              setActiveFrame(index);
            }
          });
        },
        { threshold: [0.55, 0.75] }
      );
      frames.forEach(function (frame) {
        observer.observe(frame);
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!isScrollView()) return;
        updateProgress();
        hideHint();
      },
      { passive: true }
    );
    updateProgress();
    setActiveFrame(0);

    window.addEventListener('keydown', function (event) {
      if (!isScrollView()) return;
      if (
        event.key !== 'ArrowDown' &&
        event.key !== 'ArrowUp' &&
        event.key !== 'PageDown' &&
        event.key !== 'PageUp'
      ) {
        return;
      }
      var activeIndex = getActiveIndex();
      var nextIndex = activeIndex;
      if (event.key === 'ArrowDown' || event.key === 'PageDown') {
        nextIndex = Math.min(activeIndex + 1, frames.length - 1);
      }
      if (event.key === 'ArrowUp' || event.key === 'PageUp') {
        nextIndex = Math.max(activeIndex - 1, 0);
      }
      if (nextIndex !== activeIndex) {
        event.preventDefault();
        scrollToFrame(nextIndex);
      }
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        scrollToFrame(getActiveIndex() - 1);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollToFrame(getActiveIndex() + 1);
      });
    }
    if (topButton) {
      topButton.addEventListener('click', function () {
        hideHint();
        var intro = document.getElementById('gallery-intro');
        if (intro) {
          intro.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }

    window.setTimeout(hideHint, 9000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryInteractions);
  } else {
    initGalleryInteractions();
  }
})();
